import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject, concat, of, filter, distinctUntilChanged, debounceTime, tap, switchMap, catchError, map, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from '../_services/auth.service';
import { BaseService } from '../_services/base.service';

@Component({
  selector: 'app-login-reg',
  templateUrl: './login-reg.component.html',
  styleUrls: ['./login-reg.component.scss']
})
export class LoginRegComponent implements OnInit {
	environment = environment;
	routeDate = {};

	regForm: FormGroup = this.fb.group({
		company_name: ['', Validators.required],
		firstname: ['', Validators.required],
		lastname: ['', Validators.required],
		email: ['', Validators.required],
		contact_no: ['', Validators.required],
		address_1: ['', Validators.required],
		address_2: [''],

		address: [null, Validators.required],
		// suburb: ['', Validators.required],
		// state: ['', Validators.required],
		// postcode: ['', Validators.required],

		password: ['', Validators.required],
		confirm_password: ['', Validators.required],
	});

	loginForm: FormGroup = this.fb.group({
		username: ['', Validators.required],
		password: ['', Validators.required],
	});

	postalCodeMinLengthTerm = 1;
	postalCodes$: Observable<any> = new Observable<any>();
	postalCodeLoading = false;
	postalCodeInput$ = new Subject<any>();

	termsAgreementFlag = false;
	redirectTo:any = null;

	constructor(private fb: FormBuilder,
		private cdref: ChangeDetectorRef,
		private router: Router,
		private baseService: BaseService,
		private authService: AuthService,
		private toastr: ToastrService,
		private titleService: Title,
		private route: ActivatedRoute,) { }

	ngOnInit(): void {
		this.titleService.setTitle("Login")
		this.redirectTo = this.route.snapshot.queryParamMap.get('redirectTo');
		console.log(this.redirectTo); // Pepperoni

		this.loadPostalCodes();
		this.routeDate = this.route.data.subscribe(v => console.log(v));
	}

	loadPostalCodes() {
		this.postalCodes$ = concat(
			of([]), // default items
			this.postalCodeInput$.pipe(
				filter(res => {
					return res !== null && res.length >= this.postalCodeMinLengthTerm
				}),
				distinctUntilChanged(),
				debounceTime(800),
				tap(() => this.postalCodeLoading = true),
				switchMap(term => {
					console.log(term)
					return this.getPostCodes(term).pipe(
						catchError(() => of([])), // empty list on error
						tap(() => this.postalCodeLoading = false)
					)
				})
			)
		);
	}

	loadToPostalCodes() {
		this.postalCodes$ = concat(
			of([]), // default items
			this.postalCodeInput$.pipe(
				filter(res => {
					return res !== null && res.length >= this.postalCodeMinLengthTerm
				}),
				distinctUntilChanged(),
				debounceTime(800),
				tap(() => this.postalCodeLoading = true),
				switchMap(term => {
					console.log(term)
					return this.getPostCodes(term).pipe(
						catchError(() => of([])), // empty list on error
						tap(() => this.postalCodeLoading = false)
					)
				})
			)
		);
	}

	getPostCodes(term: any) {
		const params = {
			q: term,
		}
		return this.baseService.getPostCodeList(params, false).pipe(map(resp => {
			if (resp.Error) {
				throwError(resp.Error);
			} else {
				return resp;
			}
		}));
	}

	findInvalidControls(form: any) {
		const invalid = [];
		const controls = form.controls;
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		console.log(invalid);
		return invalid;
	}

	validateLogin() {
		if (this.loginForm.invalid) {
			this.findInvalidControls(this.loginForm)
			const msg = 'Invalid Form';
			const header = 'Please fill the required fields...';
			this.toastr.error(header, msg, {
				positionClass: 'toast-top-right',
			});
			
			document.getElementById('loginForm')?.classList.add('input-error');
		} else {
			const userData = this.loginForm.value;

			console.log("Final Login Data", userData);
			this.login(this.loginForm.get('username')?.value, this.loginForm.get('password')?.value)
		}
	}

	login(username: string, password: string) {
		this.authService.loginByHeader(username, password)
		.subscribe((response: any) => {
			if(this.redirectTo) {
				this.router.navigate([this.redirectTo]);
			} else {
				this.router.navigate(['/']);
			}
		},(error:any)=>{
			this.toastr.error('Login Error!', 'Invalid Username or password', {
				positionClass: 'toast-top-right',
			});
		});
	}

	register() {
		console.log("register clicked")
		console.log(this.regForm.value)
		if (this.regForm.invalid) {
			this.findInvalidControls(this.regForm)
			const msg = 'Invalid Form';
			const header = 'Please fill the required fields...';
			this.toastr.error(header, msg, {
				positionClass: 'toast-top-right',
			});
			
			document.getElementById('regForm')?.classList.add('input-error');
		} else {

			if(!this.termsAgreementFlag) {
				const msg = 'Invalid';
				const header = 'Please agree with terms and conditions...';
				this.toastr.warning(header, msg, {
					positionClass: 'toast-top-right',
				});
				
			}
			const userData = this.regForm.value;

			const address = this.regForm.get("address")?.value;
			userData.suburb = address.suburb;
			userData.postcode = address.postcode;
			userData.state = address.state;

			console.log("Final Register Data", userData);

			this.authService.signup(userData).subscribe({
				next: (res:any) => {
					console.log(res);
					const msg = 'Success';
					const header = 'Your account successfully created...';
					this.toastr.success(header, msg, {
						positionClass: 'toast-bottom-center',
					});
					this.login(userData.email, userData.password)
				},
				error: (err: any) => {
					const msg = 'Failed';
					const header = 'Please try again...';
					this.toastr.error(header, msg, {
						positionClass: 'toast-top-right',
					});
					this.cdref.detectChanges();
				}
			});
		}
	}

}
